import { useApiQuery } from '../useApi';

export interface TestBrand {
  id: string;
  name: string;
}

export interface TestSyllabusEntry {
  baseSubject: string;
  baseTopic: string;
  displaySubject: string;
  displayTopic: string;
}

export interface TestDefaultScores {
  correct: number;
  empty: number;
  wrong: number;
}

export interface Test {
  _id: string;
  name: string;
  description?: string;
  year: number;
  tags?: string[];
  brands: TestBrand[];
  syllabus: TestSyllabusEntry[];
  defaultScores: TestDefaultScores;
  createdAt: string;
  updatedAt: string;
}

export const testKeys = {
  all: ['tests'] as const,
  detail: (testId: string) => ['tests', testId] as const,
};

export const useGetTests = () => {
  const { data, isFetching, error } = useApiQuery<Test[]>(
    '/tests',
    testKeys.all,
    undefined,
    { staleTime: 60 * 60 * 1000, gcTime: 60 * 60 * 1000 },
  );

  return { tests: data ?? [], isFetching, error };
};

export const useGetTest = (testId: string) => {
  const { data, isFetching, error } = useApiQuery<Test>(
    `/tests/${testId}`,
    testKeys.detail(testId),
    undefined,
    { enabled: !!testId, staleTime: 60000, gcTime: 60000 },
  );

  return { test: data, isFetching, error };
};
